<template>
<div class="home">

    <div class="row no-gutters justify-content-center">
    
        <div v-if="games.length > 0" class="col-md-12 mt-4 mb-2 text-center">
            <div class="intro-container">
                <div class="row">
                    <div class="col">
                        <header>
                            Total Games
                        </header>
                        <div class="intro-stat">
                            {{ getStats(games).totalGames }}
                        </div>
                    </div>
                    <div class="col">
                        <header>
                            Winners
                        </header>
                        <div class="intro-stat">
                            {{ getStats(games).winners }}
                        </div>
                    </div>
                    <div class="col">
                        <header>
                            Winner Rewards
                        </header>
                        <div class="intro-stat">
                            {{ getStats(games).winnerRewards }} NAS
                        </div>
                    </div>
                    <div class="col">
                        <header>
                            Total Earnings
                        </header>
                        <div class="intro-stat">
                            {{ getStats(games).totalEarnings }} NAS
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div> 

    <div class="row no-gutters justify-content-center">
    
        <div class="col-md-4 mt-4 mb-4 text-center">
            <button v-if="!pendingTransaction" @click="openModal" class="btn btn-primary">
                Create a Game
            </button>
            <button v-else class="btn btn-secondary">
                Please wait ...
            </button>
        </div>

    </div>    

    <div class="row no-gutters">
        
        <div v-if="!games || games.length == 0" class="col-md-12 mb-2 text-center">
            <div v-if="!contentLoading" class="intro-container">
                Hmm ... we can't find any games. Please make one!
            </div>
            <div v-else class="intro-container">
                Loading, please wait ...
            </div>
        </div>

        <div v-for="(game, index) in games" :key="index" class="col-12 col-sm-12 col-md-6 col-lg-4">
            <div class="blockwar-item" :class="{ winner : game.winner }">
                <div class="row no-gutters mb-4">
                    <div class="col-12 text-center">
                        <div v-if="!game.isComplete" class="main-header">
                            PLAY to WIN - {{ fromWei(game.reward) }} NAS
                        </div>    
                        <div v-else-if="game.isComplete && !game.winner" class="main-header">
                            No one won! {{ fromWei(game.reward) }} NAS
                        </div>    
                        <div v-else class="main-header winner">
                            Wow! {{ game.winner.substr(game.winner.length-4, 4)}} found {{ fromWei(game.reward) }} NAS!
                        </div>                    
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-4">
                        <header>
                            Owner
                        </header>
                        <div>
                            {{ game.owner.substr(game.owner.length-4, 4) }}
                        </div>
                    </div>
                    <div class="col-4">
                        <header>
                            Grid Size
                        </header>
                        <div>
                            {{ game.gridSize }}
                        </div>
                    </div>
                    <div class="col-4">
                        <header>
                            Status
                        </header>
                        <div>
                            {{ game.isComplete ? 'Closed' : 'Open' }}
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-4">
                        <header>
                            Guesses
                        </header>
                        <div>
                            {{ game.guessCounter }} / {{ game.maxGuesses }}
                        </div>
                    </div>
                    <div class="col-4">
                        <header>
                            Price to Play
                        </header>
                        <div>
                            {{ game.price }} NAS
                        </div>
                    </div>
                    <div class="col-4">
                        <header>
                            Earnings
                        </header>
                        <div>
                            {{ fromWei(game.earnings) }} NAS
                        </div>
                    </div>
                </div>
                <div class="row pt-2">
                    <div class="col-12 text-center">
                         <button v-if="!game.isComplete" @click="goToRoute(game.id)" class="btn btn-primary">
                            Play
                        </button>
                        <button v-else @click="goToRoute(game.id)" class="btn btn-secondary">
                            View
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>

</template>

<script>
import { mapGetters } from "vuex";
import TheBanner from "../components/layout/TheBanner";
import { contractAddress, nebPay, neb } from "../util/nebulas";

export default {
    name: "Home",
    computed: {
        ...mapGetters({
            games: 'getGames',
            contentLoading: 'getContentLoading',
            pendingTransaction: 'getPendingTransaction'
        })
    },
    components: {},
    data() {
        return {};
    },
    methods: {
        openModal () {
            this.$root.$emit('bv::show::modal','modal-create');
        },

        fromWei (amount) {
            return neb.fromBasic(amount, "nas").toNumber();  
        },
        
        goToRoute (_id) {
            this.$store.commit('setGame', { id: _id });
            this.$router.push({ name: 'game', params: { id: _id }});
        },

        getStats (games) {
            let results = {
                winners: 0,
                winnerRewards: 0,
                totalEarnings: 0
            };

            for (let i = 0; i < games.length; i++) {
                 if (games[i].winner) {
                    results.winners+=1;
                    results.winnerRewards += this.fromWei(games[i].reward);
                 }

                 results.totalEarnings += this.fromWei(games[i].earnings);
            }

            results.totalGames = games.length;
            return results;
        }
    }
};
</script>

<style lang="less">
@import "../assets/less/app.less";
.home {
    color: #fff;
    padding: 0 10px 20px;
    overflow-x: hidden;

    .intro-container {
        padding: 40px;
        margin: 0 5px;
        background: #3C3F44;

        header {
            font-size: 16px;
            color: #96999C;
        }

        .intro-stat {
            font-size: 18px;
        }
    }
}

.blockwar-item {
    background: #3C3F44;
    border: 3px solid #222532;
    margin: 0 5px 12px;
    padding: 25px 0;
    text-align: center;

    &.winner {
        border: 2px solid #83A485;
    }

    .main-header {
        font-size: 20px;
        padding-bottom: 20px;
        border-bottom: 3px solid #222532;

        &.winner {
            color: #83A485;
        }
    }

    header {
        color: #96999C; 
    }
}

.grid-item {
    border: 1px solid #3c3f44;
    text-align: center;
    cursor: pointer;
    color: #3c3f44;
    padding: 30px;   

    &:hover {
        color: #ccc;
    }

    &.awake {
        background: #efefef;
    }
}

// Other
.content-container {
    cursor: default!important;
}

.home {
    .no-content {
        font-weight: bold;
        font-size: 24px;
        padding: 150px 0;
        text-align: center;
    }

    .content-body {
        position: relative;
        
        .fee {
            font-size: 13px;
            font-weight: bold;
        }
        .content-row {
            padding: 50px 0;
            text-align: center;
            

            h1 {
                margin: 20px 0 30px;
            }

            .versus {
                font-size: 32px;
                color: #000;
                position: relative;
                top: 40%;
            }


            .action-container {
                margin-top: 30px;
            }
        }

        .shape {
            width: 25%;
            position: absolute;
            opacity: 0.1;
            z-index: -1;

            &.one {
                height: 100%;
                left: 0;
                top: 0;
                background: #8E2DE2;
                -webkit-clip-path: polygon(0% 0%, 50% 100%, 0% 100%);
                clip-path: polygon(0% 0%, 40% 100%, 0% 100%);

                &.top {
                    -webkit-clip-path: polygon(0% 0%, 48% 0%, 0% 99%);
                    clip-path: polygon(0% 0%, 40% 0%, 0% 100%);
                }

                &.large {
                    -webkit-clip-path: polygon(0% 0%, 50% 100%, 0% 100%);
                    clip-path: polygon(0% 0%, 40% 0%, 0% 100%);
                }
            }

            &.two {
                height: 100%;
                right: 0;
                top: 0;
                background: #8E2DE2;
                -webkit-clip-path: polygon(1% 100%, 100% 1%, 99% 98%);
                clip-path: polygon(60% 100%, 100% 0%, 100% 100%);

                &.top {
                    -webkit-clip-path: polygon(100% 1%, 59% 0%, 100% 99%);
                    clip-path: polygon(100% 0%, 60% 0%, 100% 100%);
                }

                &.large {
                        -webkit-clip-path: polygon(1% 100%, 100% 1%, 99% 98%);
                    clip-path: polygon(60% 0%, 100% 0%, 100% 100%);
                }
            }
        }

    }
}

// Tablet device
@media only screen and (max-width: 768px) {
    body {
        .versus {
            margin: 30px 0;
            top: 0!important;
        }
    }
}

// Phone device
@media only screen and (max-width: 480px) {
     body {
        .shape {
            display: none!important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue